// @ts-nocheck
import React from 'react'
import Header from './layout/Header'
import Footer from './layout/Footer'
import useFetch from '../../ApiClient/GetApi'

export default function Privacy() {
    const {data} = useFetch("users/home/privacy_and_policy");
    
  return (
    <>
    <section className="font-fiexen">
      <Header />
        <div className='w-5/6 mx-auto py-20'>
        <h1 className='text-2xl font-semibold text-themeBlue'>Privacy & Policy</h1>
        <div dangerouslySetInnerHTML={{ __html: data?.data?.value }} />
        </div>
      <Footer />
    </section>
  </>
  )
}
